import get from "api/algolia/region";

export const REGIONS_GET = "REGIONS_GET";

export const getRegions = (countryID) => (dispatch) =>
  dispatch({
    type: REGIONS_GET,
    payload: get(countryID),
  });
